export default {
    awaitingApproval:   'awaitingapproval',
    none:               0,
    online:             1,
    offline:            2,
    onlineEmergency:    3,
};